import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Button,
  Box,
} from "@material-ui/core";
import { Views } from "../../helpers/constants";
import { useHistory } from "react-router-dom";
import { logout } from "../login/loginSlice";
import { getPurchaseURL } from "../../services/utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "1.8rem",
      width: "100%",
      marginTop: "90px",
    },
    body: {
      color: theme.palette.dark.main,
      fontSize: "1.2rem",
      marginTop: "40px",
      lineHeight: "1.5rem",
      width: "440px",
    },
    buttons: {
      color: theme.palette.paused.main,
      fontWeight: "bold",
      padding: "0px 0px",
      "&:hover": {
        background: "transparent",
      },
      minWidth: "30px",
    },
    buttonBox: {
      marginTop: "50px",
    },
    link: {
      textDecoration: "none !important",
      color: theme.palette.dark.dark,
      fontWeight: "bold",
    },
  })
);

export default function SubscriptionConfirmation() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---- Utils ---- */
  const handleBackToLogin = () => {
    dispatch(logout());
    history.push(Views.LOGIN);
  };

  return (
    <React.Fragment>
      <Typography className={classes.title}>
        {t("no_active_subscription_title")}
      </Typography>
      <Typography className={classes.body}>
        {t("no_active_subscription_body")}
        <a
          className={classes.link}
          href={getPurchaseURL()}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("here")}
        </a>
        {"."}
      </Typography>
      <Box className={classes.buttonBox}>
        <Button onClick={handleBackToLogin} className={classes.buttons}>
          {t("back")}
        </Button>
      </Box>
    </React.Fragment>
  );
}
